/**
 * I18nProvider
 * 初始化语言设置并监听变化
 */

import { useEffect, useState, type ReactNode } from 'react';
import { useLanguageStore } from '@/stores/languageStore';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isInitialized, setIsInitialized] = useState(false);
  const { initializeLanguage, language } = useLanguageStore();

  useEffect(() => {
    // 初始化语言设置
    initializeLanguage();
    setIsInitialized(true);
  }, [initializeLanguage]);

  // 语言变化时更新 document 属性
  useEffect(() => {
    if (!isInitialized) return;
    
    // 更新 HTML lang 属性
    document.documentElement.setAttribute('lang', language);
    
    // 更新 title（如果需要）
    // document.title = getPageTitle(language);
  }, [language, isInitialized]);

  // 避免闪烁，初始化完成前显示 loading 或 null
  if (!isInitialized) {
    return null; // 或返回一个极简的 loading 状态
  }

  return <>{children}</>;
}
